import { Injectable } from '@angular/core'
import { FormGroup, FormBuilder } from '@angular/forms'
import { MyUtilityService } from '@app/shared/services/my-utility.service'
import { LocalStorageService } from 'angular-2-local-storage'
import { SavedQueryApiService } from '@app/modules/saved-query/saved-query-api.service'
import { SavedQuery } from '@app/modules/saved-query/saved-query.model'
import { BehaviorSubject } from 'rxjs'

@Injectable()

export class SavedQueryService {

  /**
   * Loaded query
   */
  public loadedQuery: BehaviorSubject<SavedQuery> = new BehaviorSubject(null)

  /**
   * Deleted query
   */
  public deletedQuery: BehaviorSubject<string> = new BehaviorSubject(null)

  /**
   * Constructor
   */
  public constructor (
    public formBuilder: FormBuilder,
    private localStorageService: LocalStorageService,
    public myUtil: MyUtilityService,
    public api: SavedQueryApiService
  ) {}

  /**
   * Pagination
   */
  public pagination: any | Object = {
    currentPage: 1,
    pageSize: 20,
    currentPageSize: 0,
    totalItems: 0,
    itemIds: []
  }

  /**
   * Sort
   */
  public sort: any | Object = {
    column: 'savedQuery.name',
    direction: 'ASC'
  }

  // ---------------------------------------------------------------------------
  // Search
  // ---------------------------------------------------------------------------

  /**
   * Get search form
   */
  public getSearchForm (): FormGroup {
    const form: FormGroup = this.formBuilder.group({
      name: [
        null,
        []
      ],
      description: [
        null,
        []
      ]
    })

    return form
  }

  /**
   * Set sort
   */
  public setSort (column: string): void {
    if (this.sort.column === column) {
      if (this.sort.direction === 'DESC') {
        this.sort.direction = 'ASC'
      } else {
        this.sort.direction = 'DESC'
      }
    } else {
      this.sort.column = column
      this.sort.direction = 'ASC'
    }
  }

  /**
   * Search
   */
  public searchItems (searchFilters: any | Object): Promise<any> {
    console.log('searchFilters', searchFilters)
    const filters: Array<any> = []

    if (searchFilters.name) {
      filters.push({
        key: 'name',
        value: searchFilters.name,
        operator: 'ct'
      })
    }

    if (searchFilters.description) {
      filters.push({
        key: 'description',
        value: searchFilters.description,
        operator: 'ct'
      })
    }

    const filterGroups: Array<any> = []

    if (filters.length > 0) {
      filterGroups.push(
        {
          or: false,
          filters: filters
        }
      )
    }

    const params: any | Object = {
      sort: [
        {
          key: this.sort.column,
          direction: this.sort.direction
        }
      ],
      filter_groups: filterGroups,
      fields: [
        'saved_query.uuid'
      ]
    }

    // Get the total results.
    return this.api.count(params)
    .toPromise()
    .then((totalResults) => {
      this.pagination.totalItems = totalResults.count

      // Add pagination and includes for result set.
      params.page = (this.pagination.currentPage - 1)
      params.limit = this.pagination.pageSize
      delete params.fields

      return this.api.getMany(params)
      .toPromise()
      .then((results) => {
        return results
      })
      .catch((err) => {
        throw err
      })

    })
    .catch((err) => {
      throw err
    })
  }

  /**
   * Set item ids
   *
   * Store the oportunity ids so we can retrive them from the edit view
   * for prev/next.
   */
  public setItemIds (totalResults: Array<any>): void {
    const itemIds: Array<number> = []
    totalResults.map((item) => {
      itemIds.push(item.uuid)
    })

    this.localStorageService.set('savedQueryUuids', itemIds)

    this.pagination.itemIds = itemIds
  }

  /**
   * Get mini nav
   */
  public getMiniNav (currentUuid: string): any {
    const miniNav: any = {
      prevId: null,
      current: currentUuid,
      nextId: null,
      total: null
    }

    if (this.pagination.itemIds.length === 0) {
      const itemIds: any = this.localStorageService.get('savedQueryUuids')
      if (itemIds !== null) {
        this.pagination.itemIds = itemIds
      }
    }

    miniNav.total = this.pagination.itemIds.length

    let i: number
    i = 0

    this.pagination.itemIds.map((item) => {
      if (item === currentUuid && !this.myUtil.isEmpty(this.pagination.itemIds[i + 1])) {
        miniNav.nextId = this.pagination.itemIds[i + 1]
      }
      if (item === currentUuid) {
        miniNav.current = (i + 1)
      }

      if (item === currentUuid && !this.myUtil.isEmpty(this.pagination.itemIds[i - 1])) {
        miniNav.prevId = this.pagination.itemIds[i - 1]
      }
      i++
    })

    return miniNav
  }

  /**
   * Save saved query group
   */
  public saveSavedQuery (savedQuery: SavedQuery): Promise<any> {
    console.log('savedQuery.saveSavedQuery()', savedQuery)

    // Save the contact group.
    return this.api.save(savedQuery)
    .toPromise()
    .then((savedQueryResult) => {
      // const uuid: string = contactGroupResult.uuid
      const promises: Array<Promise<any>> = []
      // Save & or Delete the ...
      return Promise.all(promises)
      .then(() => {
        return savedQueryResult
      })
      .catch((err) => {
        throw err
      })

    })
    .catch((err) => {
      throw err
    })

  }

  /**
   * Load saved query
   */
  public loadSavedQuery (savedQuery: SavedQuery): void {
    this.loadedQuery.next(savedQuery)
  }

  /**
   * Load saved query
   */
  public deletedSavedQuery (uuid: string): void {
    this.deletedQuery.next(uuid)
  }

}
